import { ForgeProjectContext } from "@supernova-studio/model";
import { z } from "zod";
import { DTONpmRegistryConfig } from "../workspaces";

export const DTOForgeProjectContext = ForgeProjectContext;

export const DTOCreateForgeProjectContext = DTOForgeProjectContext.pick({
  definition: true,
  name: true,
  meta: true,
  designSystemId: true,
  platform: true,
  dependencies: true,
  tailwindConfig: true,
  styling: true,
}).extend({ npmProxySettings: DTONpmRegistryConfig });

export const DTOUpdateForgeProjectContext = DTOForgeProjectContext.extend({ id: z.string() });

export const DTOForgeProjectContextGetResponse = z.object({ context: DTOForgeProjectContext.nullable() });

export const DTOForgeProjectContextListResponse = z.object({ contexts: z.array(DTOForgeProjectContext) });

export const DTOForgeProjectContextCreateResponse = z.object({ context: DTOForgeProjectContext });

export const DTOForgeProjectContextUpdateResponse = z.object({ context: DTOForgeProjectContext.nullable() });

export const DTOForgeProjectContextRemoveResponse = z.object({
  ok: z.literal(true),
});

export type DTOForgeProjectContext = z.infer<typeof DTOForgeProjectContext>;
export type DTOCreateForgeProjectContext = z.infer<typeof DTOCreateForgeProjectContext>;
export type DTOUpdateForgeProjectContext = z.infer<typeof DTOUpdateForgeProjectContext>;
export type DTOForgeProjectContextGetResponse = z.infer<typeof DTOForgeProjectContextGetResponse>;
export type DTOForgeProjectContextListResponse = z.infer<typeof DTOForgeProjectContextListResponse>;
export type DTOForgeProjectContextCreateResponse = z.infer<typeof DTOForgeProjectContextCreateResponse>;
export type DTOForgeProjectContextUpdateResponse = z.infer<typeof DTOForgeProjectContextUpdateResponse>;
export type DTOForgeProjectContextRemoveResponse = z.infer<typeof DTOForgeProjectContextRemoveResponse>;
